import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  button: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "inherit",
    borderRadius: 12,
    boxShadow: "0px 4px 9px rgba(0, 0, 0, 0.1)",
    background: theme.palette.bkg.secondary,
    padding: "12px 16px",
    "&:hover": {
      backgroundColor: "#dcdcdc",
      boxShadow: "none",
    },
  },
  makeModelContainer: {
    display: "flex",
    justifyContent: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  makeText: {
    color: (props) =>
      props.make
        ? "initial !important"
        : `${theme.palette.text.secondary} !important`,
  },
  modelText: {
    color: (props) => (props.model ? "initial" : theme.palette.text.secondary),
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    display: "block",
  },
  middleDot: {
    color: (props) => (props.model ? "initial" : theme.palette.text.secondary),
    padding: "0 4px",
  },
  ghostItem: {
    visibility: "hidden",
    width: 24,
    height: 24,
  },
  buttonContainer: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      width: 300,
      height: 48,
      marginRight: 12,
    },
    position: "relative",
  },
  clearButton: {
    position: "absolute",
    top: 13,
    right: 10,
    cursor: "pointer",
  },
}));
